import React, { Component } from 'react';
import Player from './Player/Player'

import logo from './logo.svg'

import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <img src={logo} className="App__logo" alt="logo" />
        
        <Player />
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/